import { render, staticRenderFns } from "./PasesNewOrEdit.vue?vue&type=template&id=e1545492&scoped=true&"
import script from "./PasesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./PasesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./PasesNewOrEdit.vue?vue&type=style&index=0&id=e1545492&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1545492",
  null
  
)

export default component.exports